// src/components/ui/Logo.jsx
import React from "react";
import { motion } from "framer-motion";

export default function Logo() {
  return (
    <motion.img
      src="/Logo.png"
      alt="Trăiește-ți Designul"
      className="h-8 md:h-10"
      initial={{ opacity: 0, y: -5 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    />
  );
}
